import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import AdminSideBarButton from "@components/Sidebar/Admin/SidebarButton";

import "@fortawesome/fontawesome-free/css/all.min.css";
import { layoutUtils } from "@/utils/layoutUtils";
import { useTranslation } from "@/hooks/useTranslation";

// Longest path first, so a nested route (e.g. "/admin/facturation/configuration")
// matches before its shorter sibling ("/admin") does.
const buttonsByPathLength = [...layoutUtils.sideBarButtons.admin].sort(
    (a, b) => b.path.length - a.path.length
);

export const AdminLeftSidebar = ({ sidebarVisible }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState("dashboard");

  useEffect(() => {
    const path = location.pathname;
    const match = buttonsByPathLength.find(
        (item) => path === item.path || path.startsWith(`${item.path}/`)
    );
    if (match) setActiveKey(match.key);
  }, [location.pathname]);

  // Same two-tier layout as NonAdminLeftSidebar: an in-flow spacer (sized to
  // match the panel) preserves the column width for the main content, while
  // the actual panel is fixed below the header via --header-h so it stays
  // visible while scrolling without ever covering the header/logo.
  const ref = useRef(null);
  const [itemWidth, setitemWidth] = useState(0);

  // Observe (not measure once): translated labels change the panel's width on
  // a UI-language switch, and the spacer must track it.
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => setitemWidth(el.getBoundingClientRect().width);
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, [sidebarVisible]);

  return (
      <div
          className="transition-all"
          style={{ minWidth: sidebarVisible ? itemWidth : 60 }}
      >
        <div
            ref={ref}
            style={{
              background: "#00BED4",
              borderRadius: 16,
            }}
            className="flex flex-col gap-3 p-4 fixed top-[var(--header-h,100px)] left-4 rtl:left-auto rtl:right-4 z-40 transition-all max-h-[calc(100vh-var(--header-h,100px)-16px)] overflow-y-auto"
        >
          {layoutUtils.sideBarButtons.admin.map(({ path, key, icon }) => (
              <Link key={path} to={path} className={"w-full"}>
                <AdminSideBarButton
                    expand={sidebarVisible}
                    label={t(`nav.admin.${key}`)}
                    icon={icon}
                    active={activeKey === key}
                    onClick={() => setActiveKey(key)}
                />
              </Link>
          ))}

          <div
              className={`w-full justify-center flex ${
                  sidebarVisible ? "gap-2" : "flex-col"
              }`}
              style={{
                textAlign: "center",
                color: "whitesmoke",
                fontSize: 15,
                fontFamily: "revert",
                fontWeight: "400",
                wordWrap: "break-word",
              }}
          >
            <span>©{new Date().getFullYear()}</span>{" "}
            <span>Tale{!sidebarVisible ? "" : `. ${t("common.allRightsReserved")}`}</span>
            <br />
            <br />
          </div>
        </div>
      </div>
  );
};
